exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnDiv[data-v-7d9f24f4] .el-button--mini{padding:7px 10px!important;margin-left:2px!important}", ""]);

// exports
